import React, { useState, useEffect, useRef } from 'react';
import { get_auth_key, getStoredData } from '../../util';
import { get, post, put } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY, units, item_classes, indentOrderType } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import Company from '../../components/company';
import Factory from '../../components/factory';
import Vendor from '../../components/vendor';
import moment from 'moment';
import { FiTrash2 } from 'react-icons/fi';
import { TbCopy } from 'react-icons/tb';
import './indent.css';
import { Link } from 'react-router-dom';
import Item from '../../components/item';

const Indents = () => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'inventory-admin'].includes(storedData.role);
  const formFields = {
    indentNumber: '',
    companyId: !admins ? storedData?.companyId || '' : '',
    factoryId: !admins ? storedData?.locationId[0] || '' : '',
    orderType: '',
  };
  const indentFields = [{ item: '', unit: '', quantity: '' }];
  const clickToDownload = useRef(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [indentList, setIndentList] = useState([]);
  const [formDetails, setFormDetails] = useState(formFields);
  const [showModel, setShowModel] = useState(false);
  const [factories, setFactories] = useState([]);
  const [company, setCompany] = useState(!admins ? storedData?.companyId || '' : '');
  const [filteredFactories, setFilteredFactories] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [indentDetails, setIndentDetails] = useState(indentFields);
  const [flashRowIndex, setFlashRowIndex] = useState(-1);
  const clickSubmitBtn = useRef(null);
  const [filters, setFilters] = useState({
    query: '',
    queryOrderType: '',
    factoryId: !admins ? storedData?.locationId[0] || '' : '',
    vendorId: '',
  });

  const handleShow = () => {
    setShowModel(true);
    makeIndentNumber();
  };
  const addIndent = () => {
    const newObject = { item: '', unit: '', quantity: '' };
    setIndentDetails([...indentDetails, newObject]);
  };

  const handleItemChange = (index, itemId) => {
    const updatedIndentDetails = [...indentDetails];
    updatedIndentDetails[index].itemId = itemId;
    const foundItem = itemList.find((item) => item.id === +itemId);
    if (foundItem) {
      updatedIndentDetails[index].unit = foundItem.unit;
    } else {
      updatedIndentDetails[index].unit = '';
    }
    setIndentDetails(updatedIndentDetails);
  };

  const handleIndentDetailChange = (index, field, value) => {
    const updatedIndentDetails = [...indentDetails];
    updatedIndentDetails[index][field] = value;
    setIndentDetails(updatedIndentDetails);
  };

  const handleClose = () => {
    setShowModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    try {
      get('/inv/indents/?id=' + id).then((item) => {
        if (item?.data?.rows?.length) {
          const itemData = item.data.rows[0];
          setFormDetails({ ...itemData });
          setIndentDetails(itemData?.RawMaterialIndentDetails);
          setShowModel(true);
        } else {
          toast.error('Invalid Item id');
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    let _formDetails = { ...formDetails, [name]: value };
    setFormDetails(_formDetails);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in formDetails) {
      try {
        await put({ ...formDetails, indentDetails }, '/inv/indents/' + formDetails.id);
        toast.success('Item updated successfully');
        setShowModel(false);
        getIndents();
        clearForm();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 3000 });
      }
    } else {
      try {
        await post({ ...formDetails, indentDetails }, '/inv/indents');
        toast.success('Indent added successfully');
        setShowModel(false);
        getIndents();
        clearForm();
      } catch (err) {
        if (err?.response?.data?.data?.message.startsWith('We already') === true) {
          makeIndentNumber();
          clickSubmitBtn.current.click();
        }
        toast.error(err.response.data.message || err.response.data.data.message || err.message, { autoClose: 2000 });
      }
    }
  };

  const clearForm = () => {
    setCompany('');
    setFormDetails(formFields);
    setIndentDetails(indentFields);
  };

  function getIndents() {
    try {
      get(
        `/inv/indents/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&vendorId=${filters.vendorId}&factoryId=${filters.factoryId}&query=${filters.query}&queryOrderType=${filters.queryOrderType}`
      ).then((response) => {
        setIndentList(response.data.rows);
        setTotalRecords(response.data.count ?? 0);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getIndents();
      }
    },
    [filters],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getIndents();
  }, [currentPage]);

  useEffect(() => {
    getFactories();
    getItems();
  }, []);

  function getItems() {
    try {
      get(`/inv/items`).then((response) => {
        setItemList(response.data.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }
  const today = moment().format('DD/MM/YYYY');
  const makeIndentNumber = () => {
    get('/inv/indents/generate-indent-number').then((res) => {
      setFormDetails({ ...formFields, indentNumber: res.data });
    });
  };

  function getFactories() {
    try {
      get(`/branches/?type=factory`).then((response) => {
        setFactories(response?.data?.rows);
        setFilteredFactories(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  const handleSelect = (e) => {
    const { value, name } = e.target;
    setFormDetails((state) => {
      return { ...state, [name]: value };
    });
  };

  const copyRow = (index) => {
    const _indentDetails = [...indentDetails];
    const rowBeingCopied = { ..._indentDetails[index], vendorId: '', quantity: '', id: '' };
    _indentDetails.splice(index + 1, 0, rowBeingCopied); // Insert at index + 1
    setFlashRowIndex(index + 1);
    setIndentDetails(_indentDetails);

    setTimeout(() => {
      setFlashRowIndex(-1);
    }, 1000);
  };

  const onCompanyChange = (e) => {
    const { value, name } = e.target;
    console.log('company', value);
    setCompany(value);
    setFormDetails((state) => {
      return { ...state, [name]: value };
    });
    setFilteredFactories(factories.filter((item) => +item.companyId === +value));
    setFormDetails((state) => {
      return { ...state, factoryId: '' };
    });
  };

  const removeIndentDetail = (indexToRemove) => {
    const updatedIndentDetails = [...indentDetails];
    updatedIndentDetails.splice(indexToRemove, 1);
    setIndentDetails(updatedIndentDetails);
  };

  const downloadPdf = (id) => {
    try {
      get(`/inv/indents/pdf/?id=${id}`).then((res) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
        // setIsLoading(false);
      });
    } catch (error) {
      // setIsLoading(false);
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Indents | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <Vendor
                name="vendorId"
                vendorId={filters?.vendorId}
                handleVendorChange={(vendorId) => {
                  setFilters({ ...filters, vendorId });
                }}
              />
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <Factory
                factoryId={filters.factoryId}
                onChange={(e) => {
                  setFilters({ ...filters, factoryId: e.target.value });
                }}
                factories={factories}
                label="factory"
                name="factoryId"
                disabled={!admins}
              />
            </div>
            <Form.Select
              value={filters.queryOrderType}
              onChange={(e) => setFilters({ ...filters, queryOrderType: e.target.value })}
              className="input"
              style={{ width: '200px', marginRight: '20px' }}
            >
              <option value="">Select Order Type</option>
              {indentOrderType.map((item, index) => (
                <option key={index} value={item?.value}>
                  {item?.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control
              value={filters.query}
              onChange={(e) => setFilters({ ...filters, query: e.target.value })}
              type="search"
              placeholder="Search by Indent Number"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
              Add Indent
            </button>
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th rowSpan="2" className="text-center">
                      Sl No.
                    </th>
                    <th rowSpan="2" className="text-center">
                      Indent Number
                    </th>
                    <th rowSpan="2" className="text-center">
                      {' '}
                      Factory
                    </th>
                    <th rowSpan="2" className="text-center">
                      {' '}
                      Order Type
                    </th>
                    <th colSpan="3" className="text-center">
                      Order Details
                    </th>
                    <th rowSpan="2" className="text-center">
                      Raised By
                    </th>
                    <th rowSpan="2" className="text-center">
                      {' '}
                      Created At
                    </th>
                    <th rowSpan="2" className="text-center">
                      Action
                    </th>
                  </tr>
                  <tr>
                    <th style={{ width: '150px', textAlign: 'center' }}>Item</th>
                    <th style={{ width: '150px', textAlign: 'center' }}>Quantity</th>
                    <th style={{ width: '150px', textAlign: 'center' }}>Vendor</th>
                  </tr>
                </thead>
                <tbody>
                  {indentList.map((item, index) => {
                    const rowSpan = item?.RawMaterialIndentDetails.length;
                    return (
                      <>
                        <tr role="row" key={item?.id}>
                          <td className="text-center" rowSpan={rowSpan}>
                            {(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}
                          </td>
                          <td className="text-center" rowSpan={rowSpan}>
                            {item?.indentNumber}
                          </td>
                          <td className="text-center" rowSpan={rowSpan}>
                            {item?.Branch?.name}
                          </td>
                          <td className="text-center" rowSpan={rowSpan}>
                            {item?.orderType}
                          </td>

                          <td className="text-center">{item?.RawMaterialIndentDetails[0].Item.name}</td>
                          <td className="text-center">{`${item?.RawMaterialIndentDetails[0].quantity} (${item?.RawMaterialIndentDetails[0].unit})`}</td>
                          <td className="text-center">{item?.RawMaterialIndentDetails[0]?.VendorMaster?.name}</td>
                          <td className="text-center" rowSpan={rowSpan}>
                            {item?.User?.name}
                          </td>
                          <td className="text-center" rowSpan={rowSpan}>
                            {moment(item?.createdAt).format('DD/MM/YYYY')}
                          </td>
                          <td className="actions" rowSpan={rowSpan}>
                            {moment(item?.createdAt).format('DD/MM/YYYY') !== today ? (
                              'PO Generated'
                            ) : (
                              <span className="edit-icon" style={{ color: '#3c8dbc' }} onClick={(e) => handleEdit(e, item?.id)}>
                                {item?.RawMaterialIndentDetails[0].vendorId === null ? 'Assign Vendors' : 'Assigned Vendors'}
                              </span>
                            )}

                            <span> | </span>
                            <Link to={`/indents/print/${item?.id}`} target="_blank" className="edit-icon" style={{ color: '#3c8dbc' }}>
                              Print
                            </Link>
                            <span> | </span>
                            <span
                              className="edit-icon"
                              style={{ color: '#3c8dbc' }}
                              onClick={() => {
                                downloadPdf(item?.id);
                              }}
                            >
                              PDF
                            </span>
                          </td>
                        </tr>
                        {item?.RawMaterialIndentDetails.map((detail, index) => {
                          if (index === 0) {
                            return null; // Skip rendering the first item
                          }
                          return (
                            <tr key={index}>
                              <td className="text-center">{detail.Item.name}</td>
                              <td className="text-center">{`${detail.quantity} (${detail.unit})`}</td>
                              <td className="text-center">{detail?.VendorMaster?.name}</td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        aria-labelledby="example-custom-modal-styling-title"
        dialogClassName="modal-60w"
        show={showModel}
        backdrop="static"
        keyboard={false}
        className="request-modal"
      >
        <Modal.Header>
          <Modal.Title>{'id' in formDetails ? 'Edit Indent' : 'Add Indent'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <h6>Indent Number: {formDetails.indentNumber}</h6>
            {!('id' in formDetails) && (
              <Row>
                <Col xs={4}>
                  <FloatingLabel label="Company" className="mb-3">
                    <Company name={'companyId'} company={company} onChange={onCompanyChange} label="Company" disabled={!admins} />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel label="Factory" className="mb-3">
                    <Factory
                      name={'factoryId'}
                      factoryId={formDetails.factoryId}
                      label={'Factory'}
                      onChange={handleSelect}
                      company={company}
                      factories={filteredFactories}
                      disabled={!admins}
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel label="Order Type" className="mb-3">
                    <select
                      required
                      name="orderType"
                      value={formDetails.orderType}
                      onChange={handleChange}
                      aria-label="Floating label select example"
                      className="form-select"
                    >
                      <option value="">Select Order Type</option>
                      {indentOrderType.map((item, index) => (
                        <option key={index} value={item?.value}>
                          {item?.label}
                        </option>
                      ))}
                    </select>
                  </FloatingLabel>
                </Col>
              </Row>
            )}

            <h6>Indent detatils:</h6>
            {indentDetails.map((indentDetail, index) => {
              return (
                <Row key={index} className={` ${index === flashRowIndex ? 'flash-row' : ''}`}>
                  {/* Item dropdown */}
                  <Col xs={4}>
                    <Item itemId={indentDetail.itemId} onChange={(itemId) => handleItemChange(index, itemId)} name="itemId" />
                  </Col>
                  {/* Vendor dropdown */}
                  {'id' in formDetails && (
                    <Col xs={3}>
                      <Vendor
                        name="vendorId"
                        vendorId={indentDetail.vendorId}
                        handleVendorChange={(vendorId) => {
                          handleIndentDetailChange(index, 'vendorId', vendorId);
                        }}
                      />
                    </Col>
                  )}
                  <Col xs={2}>
                    <FloatingLabel label="Unit" className="mb-3">
                      <select
                        required
                        name="unit"
                        value={indentDetail.unit}
                        onChange={(e) => handleIndentDetailChange(index, 'unit', e.target.value)}
                        aria-label="Floating label select example"
                        className="form-select"
                      >
                        <option value="">Select Unit</option>
                        {units.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item?.label}
                          </option>
                        ))}
                      </select>
                    </FloatingLabel>
                  </Col>
                  {/* Quantity */}
                  <Col xs={2}>
                    <FloatingLabel label="Quantity" className="mb-3">
                      <Form.Control
                        className="input"
                        name="quantity"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (!isNaN(value) && value >= 0) {
                            handleIndentDetailChange(index, 'quantity', value);
                          }
                        }}
                        value={indentDetail.quantity}
                        type="text"
                        placeholder="Quantity"
                        required
                        autoComplete="false"
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={1} className="align-middle">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {'id' in formDetails && (
                        <TbCopy
                          style={{ fontSize: '20px', cursor: 'pointer' }}
                          title="Copy Item"
                          className="react-icons"
                          onClick={() => {
                            copyRow(index);
                          }}
                        />
                      )}

                      <FiTrash2
                        style={{ fontSize: '20px', cursor: 'pointer' }}
                        color="red"
                        title="Remove Item"
                        className="react-icons red mt-2"
                        onClick={() => {
                          removeIndentDetail(index);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              );
            })}
            <Row>
              <Col xs={12}>
                <Button variant="secondary" size="sm" onClick={addIndent}>
                  + Add Items
                </Button>
                <Button
                  ref={clickSubmitBtn}
                  onClick={handleSubmit}
                  type="submit"
                  className="add-request-btn mt-4 mb-3 justify-content-center"
                >
                  {'id' in formDetails ? 'Update' : 'Create Indent'}
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Indents;
